import { createSlice } from "@reduxjs/toolkit";
import { sync_meta_templates_thunk, get_all_templates_thunk, get_template_buttons_list_thunk, get_root_template_thunk, set_root_template_thunk, get_mediaurl_by_templateid_thunk, set_mediaurl_by_templateid_thunk, create_thread_thunk } from "./threads-thunk";

const initialState = {
  loading: false,
  data: [],
  sync_data: [],
  templatebuttons_data: [],
  roottemplate_getdata: [],
  roottemplate_setdata: [],
  mediaurl_getdata: [],
  mediaurl_setdata: [],
  save_data: [],
};

const threadsslice = createSlice({
  name: "threadsslice",
  initialState,
  reducers: {},
  extraReducers: {
    [sync_meta_templates_thunk.pending]: (state, action) => {
      state.loading = true;
      state.sync_data = [];
    },
    [sync_meta_templates_thunk.fulfilled]: (state, action) => {
      console.log("--> sync_meta_templates_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.sync_data = action.payload ? action.payload : [];
    },
    [sync_meta_templates_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.sync_data = [];
    },

    [get_all_templates_thunk.pending]: (state, action) => {
      state.loading = true;
      state.data = [];
    },
    [get_all_templates_thunk.fulfilled]: (state, action) => {
      console.log("--> get_all_templates_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.data = action.payload ? action.payload : [];
    },
    [get_all_templates_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.data = [];
    },

    [get_template_buttons_list_thunk.pending]: (state, action) => {
      state.loading = true;
      state.templatebuttons_data = [];
    },
    [get_template_buttons_list_thunk.fulfilled]: (state, action) => {
      console.log("--> get_template_buttons_list_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.templatebuttons_data = action.payload ? action.payload : [];
    },
    [get_template_buttons_list_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.templatebuttons_data = [];
    },

    [get_root_template_thunk.pending]: (state, action) => {
      state.loading = true;
      state.roottemplate_getdata = [];
    },
    [get_root_template_thunk.fulfilled]: (state, action) => {
      console.log("--> get_root_template_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.roottemplate_getdata = action.payload ? action.payload : [];
    },
    [get_root_template_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.roottemplate_getdata = [];
    },

    [set_root_template_thunk.pending]: (state, action) => {
      state.loading = true;
      state.roottemplate_setdata = [];
    },
    [set_root_template_thunk.fulfilled]: (state, action) => {
      console.log("--> set_root_template_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.roottemplate_setdata = action.payload ? action.payload : [];
    },
    [set_root_template_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.roottemplate_setdata = [];
    },

    [get_mediaurl_by_templateid_thunk.pending]: (state, action) => {
      state.loading = true;
      state.mediaurl_getdata = [];
    },
    [get_mediaurl_by_templateid_thunk.fulfilled]: (state, action) => {
      console.log("--> get_mediaurl_by_templateid_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.mediaurl_getdata = action.payload ? action.payload : [];
    },
    [get_mediaurl_by_templateid_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.mediaurl_getdata = [];
    },

    [set_mediaurl_by_templateid_thunk.pending]: (state, action) => {
      state.loading = true;
      state.mediaurl_setdata = [];
    },
    [set_mediaurl_by_templateid_thunk.fulfilled]: (state, action) => {
      console.log("--> set_mediaurl_by_templateid_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.mediaurl_setdata = action.payload ? action.payload : [];
    },
    [set_mediaurl_by_templateid_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.mediaurl_setdata = [];
    },

    [create_thread_thunk.pending]: (state, action) => {
      state.loading = true;
      state.save_data = [];
    },
    [create_thread_thunk.fulfilled]: (state, action) => {
      console.log("--> create_thread_thunk fulfilled | action.payload: ", action.payload);
      state.loading = false;
      state.save_data = action.payload ? action.payload : [];
    },
    [create_thread_thunk.rejected]: (state, action) => {
      state.loading = false;
      state.save_data = [];
    },
  },
});

export default threadsslice.reducer;
